import { getCountries, getCountryCallingCode } from 'libphonenumber-js/min';

/**
 * @param {string} bcp47Locale — ex.: 'pt-BR', 'en-US'
 * @returns {Array<{ iso: string, dialCode: string, name: string, searchText: string }>}
 */
export function buildPhoneCountries(bcp47Locale) {
  const locales = [bcp47Locale, 'en-US'];
  let displayNames;
  try {
    displayNames = new Intl.DisplayNames(locales, { type: 'region' });
  } catch {
    displayNames = new Intl.DisplayNames(['en-US'], { type: 'region' });
  }

  const isoList = getCountries();
  const items = isoList.map((iso) => {
    const dial = getCountryCallingCode(iso);
    const dialNorm = String(dial);
    let name;
    try {
      name = displayNames.of(iso);
    } catch {
      name = iso;
    }
    const searchText = [
      iso.toLowerCase(),
      name.toLowerCase(),
      dialNorm,
      `+${dialNorm}`,
      `+${dial}`
    ].join(' ');
    return {
      iso,
      dialCode: dialNorm,
      name,
      searchText
    };
  });

  return items.sort((a, b) => a.name.localeCompare(b.name, bcp47Locale));
}
